module.exports = __webpack_public_path__ + "static/media/bournemouth.32e46ee8.png";